import { Ddbox } from "./ddbox";
import { Swimmer } from "./swimmer";
import { MarketingClientShareArticleOld } from "./marketing-client-share-article-old";
import { MarketingClientShareArticle } from "./marketing-client-share-article";
import { Hat } from "./marketing-client-hat";
import { MarketingClientRWFirstPromotion } from "./marketing-client-rw-first-promotion";
import { MarketingClientRWSecondPromotion } from "./marketing-client-rw-second-promotion";
import { Capping } from "./marketing-client-capping";
import { Utilization } from "./marketing-client-utilization";
import { MarketingClientRWOwner } from "./marketing-client-rw-owner";
import { OneDayPass } from "./marketing-client-one-day-pass";
import { OneDayPassOld } from "./marketing-client-one-day-pass-old";
import { DOMHelper } from "./helpers/dom-helper";
import { RwSelector } from "./constants/rw-object.constants";
import { SwfSelector } from "./constants/swf-constants";
import { AppleId } from "./utils/appleid";
import RecommendationsCop from "./utils/recommendations-cop/recommendations-cop";
import { Theme } from "./marketing-client-theme";
import { Selector } from "./constants/one-day-pass-old-constants";
import { ClosingWithoutLp } from "./marketing-client-closing-without-lp";

export class MarketingClientBanners {
    colotTheme: Theme;
    ddbox: Ddbox;
    swimmer: Swimmer;
    hat: Hat;
    marketingClientShareArticleOld: MarketingClientShareArticleOld;
    marketingClientShareArticle: MarketingClientShareArticle;
    marketingClientRWOwner: MarketingClientRWOwner;
    marketingClientRWFirstPromotion: MarketingClientRWFirstPromotion;
    marketingClientRWSecondPromotion: MarketingClientRWSecondPromotion;
    oneDayPass: OneDayPass;
    oneDayPassOld: OneDayPassOld;
    apple: AppleId;
    recommendationsCop: RecommendationsCop;
    closingWithoutLp: ClosingWithoutLp;

    constructor(capping: Capping, utilization: Utilization, isMobile: boolean) {
        this.colotTheme = new Theme();
        this.ddbox = new Ddbox(isMobile, capping);
        this.hat = new Hat(isMobile);
        this.swimmer = new Swimmer(isMobile, capping);
        this.marketingClientShareArticleOld = new MarketingClientShareArticleOld(utilization);
        this.marketingClientShareArticle = new MarketingClientShareArticle(utilization);
        this.marketingClientRWFirstPromotion = new MarketingClientRWFirstPromotion(capping, utilization);
        this.marketingClientRWSecondPromotion = new MarketingClientRWSecondPromotion(capping, utilization);
        this.marketingClientRWOwner = new MarketingClientRWOwner(capping, utilization);
        this.oneDayPass = new OneDayPass(capping, utilization);
        this.oneDayPassOld = new OneDayPassOld(capping, utilization);
        this.apple = new AppleId();
        this.recommendationsCop = new RecommendationsCop(isMobile);
        this.closingWithoutLp = new ClosingWithoutLp();
    }

    init() {
        this.colotTheme.init();
        this.ddbox.init();
        this.swimmer.init();
        this.recommendationsCop.init(this.ddbox.ddboxIsVisible);
        this.hat.init();
        this.closingWithoutLp.init();
        this.initSwf();
        this.initRw();
        this.initOneDayPass();
    }

    initRw() {
        const rwFirstPromotionDom: Element | null = DOMHelper.querySelector(RwSelector.rwFirstPromotionSelector),
            rwSecondPromotionDom: Element | null = DOMHelper.querySelector(RwSelector.rwSecondPromotionSelector);

        if (rwFirstPromotionDom) {
            this.apple.init();
            this.marketingClientRWFirstPromotion.init();
        } else if (rwSecondPromotionDom) {
            this.marketingClientRWSecondPromotion.init();
        } else {
            this.marketingClientRWOwner.init();
        }
    }

    initSwf(){
        const swfOld = DOMHelper.querySelector(SwfSelector.oldSwfSelector) as HTMLElement;
      
        if(swfOld){
            this.marketingClientShareArticleOld.init();
         } else {
            this.marketingClientShareArticle.init();
         }
    }
    
    initOneDayPass(){
        const oneDayPassOld = DOMHelper.querySelector(Selector.closeActivation) as HTMLElement;
      
        if(oneDayPassOld){
            this.oneDayPassOld.init();
         } else {
            this.oneDayPass.init();
         }
    }
}
